import { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import styles from './RouteProgressBar.module.css'

export default function RouteProgressBar() {
  const location = useLocation()
  const [visible, setVisible] = useState(false)
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    setVisible(true)
    if (timerRef.current) clearTimeout(timerRef.current)
    timerRef.current = setTimeout(() => setVisible(false), 600)
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current)
    }
  }, [location.pathname])

  return <div className={`${styles.bar} ${visible ? styles.visible : ''}`} aria-hidden="true" />
}
